<template>
	<thead class="table-header-wrapper">
		<tr>
			<header-cell-generic
			v-for="(entry, index) in parsedHeaderData"
			:key="`header_cell_${entry.dataAttr}`"
			:entry="entry"
			:data-param="entry.dataAttr"
			:class="[{'is-chrome': isChrome }, entry.rowCellType]"
			:style="tableStyles ? parsedHeaderStyles[index] :  null"
			:sortByDirection="sortByDirection"
			:selectedCell="currentSortedCell === entry.dataAttr"
			@sortBy="[emit('sortBy', $event), sortByDirection = $event.sortBy, currentSortedCell = entry.dataAttr]"/>
		</tr>
	</thead>
</template>

<script setup>
import HeaderCellGeneric from '@/components/generic/table/headers/cells/Generic'
/* Vue */
import { ref, computed } from 'vue'
/* Emmitters */
const emit = defineEmits(['sortBy'])

/** Props received:
@headerData { Array } each Object is a column in your list, and has:
	- value [String, Object]: value to send to headerCells
	- dataAttr [String, Number]: column identifier
	- mandatory {Boolean} to apply '*' in our label
	- sortable {Boolean} prop to add possibility to order by this column, we will use dataAttr to emit which column we want to sort-by
	- showInMobile [Boolean, Object]:
	-[Boolean] if we receive a boolean your cell in mobile will be a column
	-[Object] if we receive an object, your cell will have multiple lines in one column
		key: groupWith, value: dataAttr we want to pair with this cell in mobile layout
@tableStyles { Array } each Object is a column in your list, and has styles that will be injected in each cell of this column
@getMobileAppState {Boolean}
*/
const props = defineProps({
	headerData: Array,
	tableStyles: Array,
	getMobileAppState: Boolean
})

const parsedHeaderData = computed(() => {
	return props.getMobileAppState ? props.headerData.filter(obj => obj.showInMobile) : props.headerData
})

/* *********************************************
*           Parsing styles for mobile          *
********************************************* */
const parsedHeaderStyles = computed(() => {
	if (!props.getMobileAppState) return props.tableStyles

	return props.headerData.reduce((acc, columnData, i) => {
		if (!columnData.showInMobile) return acc

		acc.push(props.tableStyles ? props.tableStyles[i] : null)
		return acc
	}, [])
})

const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
const sortByDirection = ref()
const currentSortedCell = ref(parsedHeaderData.value[0].dataAttr)
</script>

<style lang="scss" scoped>
.table-header-wrapper {
	width: 100%;
	height: 48px;
}
</style>
